// extracted by mini-css-extract-plugin
export var brand = "_9r-9";
export var compact = "_9r-6";
export var extraSmall = "_9r-7";
export var icon = "_9r-0";
export var large = "_9r-4";
export var light = "_9r-1";
export var medium = "_9r-5";
export var outline = "_9r-b";
export var primaryDark = "_9r-a";
export var primaryLight = "_9r-8";
export var primaryModern = "_9r-c";
export var success = "_9r-2";
export var successSolid = "_9r-3";